import { RouteRecordRaw } from "vue-router";
import EditPage from "../EditPage.vue";
import IndexPage from "../IndexPage.vue";

export default {
  path: "brands",
  children: [
    {
      path: "",
      name: "hotel.brands",
      component: IndexPage,
    },
    {
      path: ":id",
      name: "hotel.brands.edit",
      component: EditPage,
    },
  ],
} as RouteRecordRaw;
